import { MenuProps } from 'antd';

export const createDropdownMenuItem = ({
  key,
  label,
  condition,
  width = '180px',
}: {
  key: string;
  label: React.ReactNode;
  condition: boolean;
  width?: string | number;
}): MenuProps['items'] => (condition ? [{ key, style: { width }, label }] : []);
